import { render, staticRenderFns } from "./EntityGroupDetails.vue?vue&type=template&id=ec0c4c06&"
import script from "./EntityGroupDetails.vue?vue&type=script&lang=js&"
export * from "./EntityGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec0c4c06')) {
      api.createRecord('ec0c4c06', component.options)
    } else {
      api.reload('ec0c4c06', component.options)
    }
    module.hot.accept("./EntityGroupDetails.vue?vue&type=template&id=ec0c4c06&", function () {
      api.rerender('ec0c4c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entityGroup/EntityGroupDetails.vue"
export default component.exports